<template>
  <div class="share-box">
    <van-nav-bar title="复制链接" left-arrow @click-left="$router.go(-1)" />
    <div class="share-body">
      <template v-if="user.id">
        <div class="estimate">奖励预估收益 <span class="c-red">{{ promotion_rate }}</span> 元</div>
      </template>
      <template v-else>
        <router-link class="c-red" :to="'/login?redirect=' + $route.fullPath"
          >登录</router-link
        >后才能获取佣金
      </template>
      <textarea class="content" :value="shareText" disabled> </textarea>
    </div>

   

    <div class="share-footer">
      <div class="share-footer-layer">
        <van-button type="warning" round size="large" @click="copy(code)"
          >复制链接</van-button
        >
        <van-button type="warning" round size="large" @click="copy(shareText)"
          >分享素材</van-button
        >
        <van-button type="danger" round size="large" @click="go()"
          >前往购买</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      StorageGoodInfo: {}, //缓存中带的商品详情
      code: "",
    };
  },
  created() {
    this.StorageGoodInfo = JSON.parse(window.localStorage.getItem("goodInfo"));
    this.code = this.$route.query.code;
  },
  computed: {
     ...mapState(["rate", "user"]),
      // 券后价
    price(){
       return Number((this.StorageGoodInfo.zk_final_price - this.StorageGoodInfo.coupon_amount).toFixed(2));
    },
    // 佣金折算
    promotion_rate() {
      return (
        ((Number(this.StorageGoodInfo.commission_rate) / 1000) *
          this.price *
          this.rate) /
        100
      ).toFixed(2);
    },
    shareText() {
      const text = `
8 ${this.StorageGoodInfo.title} \n
【到手价】: ${this.price}元 \n
淘口令:${this.code}
`;
      return text;
    },
  },
  methods: {
    go() {
      window.open(this.StorageGoodInfo.coupon_click_url)
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import "../../assets/less/share.less";
</style>



// WEBPACK FOOTER //
// src/pages/taobao/share.vue